import axios from "axios";
import {
  actionAuthSessionExpired,
  getCurrentIdToken,
  jwtIsExpired,
} from "./authRedux";

let axiosHandlerSetup = false;

export function setupAxiosHandler(dispatch) {
  if (axiosHandlerSetup) {
    return;
  }

  // Setup a global axios handler so we can detect when
  // REST calls start failing due to our JWT expiring.
  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      // We could check for a 401 here but that doesn't work for our
      // non-standard deployments (https://umich-mgis-has-2.mgiscloud.com/)
      // that make cross-origin REST calls.
      //
      // Instead, we just check directly whether our JWT has expired.

      // We cannot easily obtain the idToken from redux inside this
      // axios hook so we get it this way.
      const idToken = getCurrentIdToken();
      if (jwtIsExpired(idToken)) {
        dispatch(actionAuthSessionExpired());
      } else {
        console.warn("Unexpected axios error:", error);
      }
      return Promise.reject(error);
    },
  );

  axiosHandlerSetup = true;
}
